<div class="scheduled-container">
  <!-- Header Section with Total Count -->
  <div class="scheduled-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h3 class="mb-1">Scheduled Reports</h3>
        <p class="text-muted mb-0">
          Manage recurring report schedules
          @if (totalCount() > 0) {
            <span class="ms-2">•</span>
            <span class="ms-2 fw-semibold">{{ totalCount() }} total</span>
          }
        </p>
      </div>
      <button kendoButton class="cyflare-btn-primary" (click)="onNewScheduleClick()">
        ➕ New Schedule
      </button>
    </div>
  </div>

  <!-- Filters Card -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-lg-3">
          <label class="form-label small fw-semibold">Frequency</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="frequencyFilter"
            (ngModelChange)="onFilterChange()"
          >
            @for (option of frequencyOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <div class="col-lg-3">
          <button
            kendoButton
            class="cyflare-btn-secondary cyflare-btn-sm"
            (click)="clearFilters()"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Datatable -->
  <div class="card">
    <div class="card-body">
      <app-datatable
        #scheduledTable
        [data-href]="datatableUrl"
        [columns]="datatableColumns"
        [useOData]="true"
        [initialFilters]="initialFilters"
      ></app-datatable>
    </div>
  </div>
</div>
